module.exports = __webpack_public_path__ + "img/skill_testing_center.3bf5cae9.svg";